module.exports = __webpack_public_path__ + "static/docs-2c06f9cea593f4163057e42e0d234472.jpg";